import Vue from 'vue'
import {en} from './en'
import {zh} from './zh'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const messages = {
  'en': en,
  'zh': zh
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: window.sessionStorage.getItem('language') || 'zh', // set locale
  messages, // set locale messages
})


export {i18n};


// WEBPACK FOOTER //
// ./src/i18n/index.js